<template>
    <div>
        <div v-if="(column.field === 'huiyistatus') & (row !== null)">{{ transTime(row.startTime, row.endTime) }}</div>

        <div v-if="(column.field === 'flFormName') & (row !== null)">
            <span :style="{ color: transTime(row.startTime, row.endTime) === '未开始' ? '#409efe' : '#909399', cursor: transTime(row.startTime, row.endTime) === '未开始' ? 'pointer' : 'default' }" @click="transTime(row.startTime, row.endTime) === '未开始' ? initById(row) : ''">{{ $tx('hygl.components.joinMeeting') }}</span>
            <!-- <span v-if="transTime(row.startTime,row.endTime)==='未开始'">会议报名</span>
      <span v-if="transTime(row.startTime,row.endTime)==='进行中'">进行中</span>
      <span v-if="transTime(row.startTime,row.endTime)==='已结束'">已结束</span> -->
            <el-dialog :title="$tx('hygl.components.joinMeeting')" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px" :before-close="handleClose">
                <p style="width: 96%; margin: 0 2%">
                    <el-button style="float: right; margin-bottom: 10px" @click="innerVisibleclick">{{ $tx('hygl.components.addMeetingPerson') }}</el-button>
                </p>
                <el-table v-model="tableDataPeople" border :data="tableDataPeople" style="width: 96%; margin: 0 2%">
                    <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                    <el-table-column :label="$tx('fields.name', '姓名')" align="center" prop="userName" />
                    <el-table-column :label="$tx('hygl.components.position')" align="center" prop="userPost" />
                    <el-table-column :label="$tx('hygl.components.depart', '部门')" align="center" prop="userDept" />
                    <el-table-column :label="$tx('hygl.components.fields.summaryPhone', '联系电话')" align="center" prop="phone" />
                    <el-table-column :label="$tx('hygl.components.personType', '人员类型')" align="center" prop="meetPersonType">
                        <template #default="scope">
                            <span v-if="scope.row.meetPersonType === 1" v-text-lbl="'insider'">内部人员</span>
                            <span v-if="scope.row.meetPersonType === 2" v-text-lbl="'outsiders'">外部人员</span>
                            <!-- <span>{{ scope.row.meetPersonType |meetPersonTypefilter }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column :label="$tx('fields.remark', '备注')" align="center" prop="remark" />

                    <el-table-column :label="$tx('pageBtns.operate', '操作')" align="center">
                        <template #default="scope">
                            <span v-pageBtn-lbl="'del'" style="cursor: pointer; color: #409efe" font-size="20px" @click="delChecked(scope.$index, scope.row)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog width="600px" :title="$tx('hygl.components.addMeetingPerson', '添加参会人员')" :visible.sync="innerVisible" :close-on-click-modal="false" append-to-body>
                    <el-form :model="addObj">
                        <div class="el-table el-table--fit el-table--border">
                            <div class="el-table__body-wrapper">
                                <table cellspacing="0" cellpadding="0" style="border: 1px solid #ebeef5" class="el-table__body">
                                    <tbody>
                                        <tr>
                                            <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                <span class="required">*</span>
                                                <span v-text-lbl="'personType'">人员类型</span>
                                            </td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="人员类型" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-radio-group v-model="meetPersonType" @change="addObjchange">
                                                            <el-radio v-text-lbl="'insider'" :label="'1'">内部人员</el-radio>
                                                            <el-radio v-text-lbl="'outsiders'" :label="'2'">外部人员</el-radio>
                                                        </el-radio-group>
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                <span class="required">*</span>

                                                <span v-field-lbl="'name'">姓名</span>
                                            </td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <ValidationProvider v-if="meetPersonType !== null" ref="ValidationProvider" v-slot="{ errors }" name="姓名" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input v-if="meetPersonType == '1'" v-model="addObj.userName" v-select-dialog="'staff'" readonly :root-org-code="row.orgCode" :org-id="bumenid" :placeholder="$tx('hygl.components.orgPlaceholder', '请选择机构员工')" name="orgStaff" resize="none" />
                                                        <el-input v-if="meetPersonType == '2'" v-model="addObj.userName" :placeholder="$tx('hygl.components.namePlaceholder', '请输入姓名')" @change="renyuanshuru" />
                                                        <!-- :org-id="innerVisible===true?loginUser.staffList.orgFullId.split('-')[0]:''" -->
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                <span class="required">*</span>
                                                <span v-text-lbl="'depart'">部门</span>
                                            </td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <ValidationProvider v-if="addObj.userDept !== null" ref="ValidationProvider" v-slot="{ errors }" name="部门" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input v-model="addObj.userDept" :readonly="meetPersonType == '1'" :placeholder="meetPersonType === '1' ? $tx('hygl.components.autoGet', '自动获取') : $tx('hygl.components.departPlaceholder', '请输入部门')" @change="bumen" />
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                <span class="required">*</span>
                                                <span v-text-lbl="'telphone'">电话</span>
                                            </td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <ValidationProvider v-if="addObj.phone !== null" ref="ValidationProvider" v-slot="{ errors }" name="电话" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input v-model="addObj.phone" :readonly="meetPersonType == '1'" :placeholder="meetPersonType === '1' ? $tx('hygl.components.autoGet', '自动获取') : $tx('hygl.components.telphonePlaceholder', '请输入电话')" @change="dianhua" />
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                <span class="required"></span>
                                                <span v-text-lbl="'position'">职位</span>
                                            </td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <el-input v-model="addObj.userPost" :readonly="meetPersonType == '1'" :placeholder="meetPersonType === '1' ? $tx('hygl.components.autoGet', '自动获取') : $tx('hygl.components.positionPlaceholder', '请输入职位')" @change="zhiwei" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                <span class="required"></span>
                                                <span v-text-lbl="'remark'">备注</span>
                                            </td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <el-input v-model="addObj.remark" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button v-pageBtn-lbl="'cancel'" @click="cellclick">取消</el-button>
                        <el-button v-pageBtn-lbl="'save'" type="primary" @click="savePeopleFuc">保 存</el-button>
                    </span>
                </el-dialog>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    filters: {
        meetPersonTypefilter(val) {
            if (val === 1) {
                return '内部人员'
            } else if (val === 2) {
                return '外部人员'
            }
        }
    },
    components: {},
    props: {
        row: {
            type: Object,
            default: function () {
                return {}
            }
        },
        column: {
            type: Object,
            default: function () {
                return {}
            }
        },
        index: {
            type: String,
            default: function () {
                return '0'
            }
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            loginUser: this.$store.getters.loginUser,
            dialogVisible: false,
            radio: 1,
            tableDataPeople: [],
            innerVisible: false,
            options: [
                {
                    value: '1',
                    label: '参会人员'
                },
                {
                    value: '2',
                    label: '联络员'
                }
            ],
            regStatus: 1,
            meetPersonType: '1',
            addObj: {},
            disableds1: false,
            disableds2: false,
            disableds3: false,
            ids: '',
            bumenid: ''
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {
        meetPersonType(val) {
            this.addObj = {}
        },
        innerVisible(val) {
            if (!val) {
                this.addObj = {}
                this.bumenid = ''
            }
        }
    },
    created() {},
    beforeDestroy() {},
    mounted() {},
    methods: {
        transTime(start, end) {
            var date = new Date()

            var startTime = new Date(start)
            var endTime = new Date(end)
            if (startTime > date) {
                return '未开始'
            } else if (endTime < date) {
                return '已结束'
            } else if (startTime < date) {
                return '进行中'
            }
        },
        addObjchange(val) {
            this.meetPersonType = null
            this.$nextTick(() => {
                this.meetPersonType = val
            })
        },
        initById(row) {
            var date = new Date()
            console.log('点击获取列表数据', row)
            var startTime = new Date(row.startTime)
            // var endTime = new Date(end)
            if (startTime > date) {
                this.getPeople()
                this.ids = row.orgFullId
                this.dialogVisible = true
            }
            // if (row.openApply === 1 && row.meetStatus === 0) {
            //     this.getPeople()
            //     this.dialogVisible = true
            // }
        },
        async innerVisibleclick() {
            this.innerVisible = true
            const arr = []
            // 对一人多个部门选出当前登录人所分配角色进行处理
            for (let i = 0; i < this.loginUser.staffList.length; i++) {
                const res = await this.$app.getById('/base/orgTreeMgr/getOrganizationById', this.loginUser.staffList[i].orgFullId.split('-')[1])
                arr.push(res.body.vo.passenger.HyglManager)
            }
            var sss = this.row.attendId.split('、')
            arr.forEach((item) => {
                item.forEach((val) => {
                    var ccc = val.orgFullId.split('-')[1]
                    sss.forEach((res) => {
                        if (ccc === res) {
                            if (this.bumenid !== '') this.bumenid += ','
                            this.bumenid += res
                        }
                    })
                })
            })
        },
        // 获取参会人员
        async getPeople() {
            const search = [
                {
                    compare: '=',
                    field: 'meetId',
                    merge: true,
                    value: this.row.id
                }
            ]
            const res = await this.$app.querydata('/hygl/meetPeople/querydata', search)
            if (res.code === 'success') {
                this.tableDataPeople = res.body.listdata
            } else {
                this.$message.error(res.message)
            }
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            console.log(selectedNodes, 303)
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += '、'
                selected = node
            })
            this.disableds2 = true
            this.disableds1 = false
            this.disableds3 = false
            this.meetPersonType = '1'
            // const num = selected.title.indexOf('\\')
            // const dept = selected.title.substring(0, num)
            const dept = selected.orgFullName.split('-')[selected.orgFullName.split('-').length - 1]
            console.log(selected.orgFullName.split('-'), dept, 315)
            this.$set(this.addObj, 'userName', selected.name)
            this.$set(this.addObj, 'orgFullOrderNo', selected.orderNo)
            this.$set(this.addObj, 'phone', selected.mobile)
            this.$set(this.addObj, 'userPost', selected.positionName)
            this.$set(this.addObj, 'userDept', dept)
            this.$set(this.addObj, 'email', selected.email)
            this.$set(this.addObj, 'userAccount', selected.account)
            this.$set(this.addObj, 'personId', selected.personId)
            // //this.$set(this.addObj, 'meetId', this.row.id)
            this.$set(this.addObj, 'regStatus', 0)
            // this.$set(this.addObj, 'meetPersonType', this.meetPersonType)
        },
        renyuanshuru(val) {
            this.disableds2 = false
            this.disableds1 = false
            this.disableds3 = false
            this.addObj.name = val
            this.$set(this.addObj, 'personId', val)
            this.$set(this.addObj, 'regStatus', 1)
            // this.meetPersonType = ''
            console.log('输入人', val)
        },
        bumen(val) {
            this.addObj.userDept = val
            console.log('输入部门', val)
        },
        dianhua(val) {
            this.addObj.phone = val
            console.log('输入电话', val)
        },
        zhiwei(val) {
            this.addObj.userPost = val
            console.log('输入职位', val)
        },
        cellclick() {
            this.innerVisible = false
            this.addObj = {}
            this.meetPersonType = '1'
        },
        // 添加人员
        async savePeopleFuc() {
            if (!this.addObj.userName) {
                this.$confirm(this.$tx('hygl.message.selectPerson2', '请选择人员！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                return false
            }
            if (!this.addObj.userDept) {
                this.$confirm(this.$tx('hygl.message.departNull', '部门不能为空！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                // this.$message.error('请选择人员！')
                return false
            }
            var re = /^1\d{10}$/ // 正则表达式
            // debugger
            if (!this.addObj.phone) {
                this.$confirm(this.$tx('hygl.message.phoneNull', '电话不能为空！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                return false
            }
            if (!re.test(this.addObj.phone)) {
                this.$confirm(this.$tx('hygl.message.phoneInvalid', '人员电话无效，请输入11位手机号!'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                return false
            }
            this.$set(this.addObj, 'meetId', this.row.id)
            // this.$set(this.addObj, 'regStatus', this.regStatus)
            this.$set(this.addObj, 'meetPersonType', this.meetPersonType)
            // if (!this.this.addObj.meetId) {
            //     debugger
            //     this.addObj.meetId=this.row.id
            // }else{
            //   //
            // }
            const res = await this.$app.insert('/hygl/meetPeople/insert', this.addObj)
            if (res.code === 'success') {
                this.$message.success(res.message)
                this.innerVisible = false
                this.getPeople()
                // this.$bus.emit('refreshListData')
                this.addObj = {}
            } else {
                this.$message.error(res.message)
            }
        },
        // 删除参会人员
        async delChecked(index, row) {
            const arrIds = []
            arrIds.push(row.id)
            console.log(arrIds)
            const res = await this.$app.deleteByIds('/hygl/meetPeople/delete', arrIds)
            if (res.code === 'success') {
                this.$message.success(res.message)
                this.getPeople()
            } else {
                this.$message.error(res.message)
            }
        }
    }
}
</script>

<style scoped lang="scss">
/deep/.el-table__body-wrapper.is-scrolling-none {
    height: 310px;
    overflow: hidden;
    overflow-y: auto;
}
/deep/.el-table .el-textarea__inner {
    height: 36px;
}
</style>
